import { TokenUsage } from './common.interface';

export interface ApiTranslationOriginalRequest {
    current_step: string;
    task_id: string;
    original_index: number;
    original_text: string;
}

export interface ApiTranslationOriginalResponse {
    status: string;
    token_usage: TokenUsage;
    content: string;
}

export const TranslationOriginal = Symbol('TranslationOriginal');

export interface TranslationOriginal {
    translationOriginal(data: ApiTranslationOriginalRequest): Promise<ApiTranslationOriginalResponse>;
}